var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-addEdit',{ref:"addEdit",attrs:{"apiOrigin":"PHP","reqLoading":_vm.reqLoading,"formList":_vm.formList,"formKey":_vm.formKey,"addParam":_vm.addParam,"editParam":_vm.editParam,"detailParam":_vm.detailParam}})}
var staticRenderFns = []

export { render, staticRenderFns }